import { Stack, styled } from "@mui/material";
import { toolbarRootName } from "../classes.js";
const excludedProps = ["as", "cssStyles", "cssVariables", "ownerState", "sx", "theme"];
const Root = styled(Stack, {
  name: toolbarRootName,
  overridesResolver: (_props, styles) => [styles.root],
  shouldForwardProp: (prop) => !excludedProps.includes(prop),
  slot: "Root"
})(({ cssStyles, cssVariables: vars }) => ({
  ...cssStyles,
  height: "100vh",
  display: "flex",
  zIndex: vars.rootZIndex
}));
export {
  Root
};
//# sourceMappingURL=Root.js.map
